/**
 * Status for metric output error_status only (evals_metricoutput.error_status).
 * Do not use for run or simulation row status.
 */
export const MetricErrorStatus = {
  IN_QUEUE: "IN QUEUE",
  IN_PROGRESS: "IN PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  SKIPPED: "SKIPPED",
} as const

export type MetricErrorStatus =
  (typeof MetricErrorStatus)[keyof typeof MetricErrorStatus]
